import { onMounted, toValue, watch, type WatchSource } from 'vue'

export function useWatchRedirectImmediate<T>(
    source: WatchSource<T>,
    callback: (newValue: T) => void
): void {
    watch(source, callback)

    const value = toValue(source)

    if (import.meta.env.SSR) {
        callback(value)
    } else {
        onMounted(() => callback(value))
    }
}
